import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CreationMode } from '@components/storage-accounts/add-storage-account-wizard/add-storage-account-wizard.constants';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { CardGroupComponent, CheckboxComponent, FormGroupComponent, InputComponent, InputPasswordComponent } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { e2eLocators, fakeSecretKey } from '../credential-forms.constants';
import { FSCredentialForm } from '../credential-forms.model';

@UntilDestroy()
@Component({
  selector: 'mbs-credential-form-file-system',
  templateUrl: './credential-form-file-system.component.html',
  styleUrls: ['../credential-forms.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CardGroupComponent,
    CheckboxComponent,
    CommonModule,
    FormGroupComponent,
    I18NextPipe,
    InputComponent,
    InputPasswordComponent,
    ReactiveFormsModule
  ]
})
export class CredentialFormFileSystemComponent implements OnInit {
  @Input() form: FSCredentialForm;
  @Input() mode: CreationMode;

  public useCredentials = new FormControl(false);
  public readonly StorageType = StorageType;
  public readonly fakeSecretKey = fakeSecretKey;
  public readonly e2eLocators = e2eLocators;

  ngOnInit() {
    this.useCredentials.valueChanges.pipe(untilDestroyed(this)).subscribe((val) => {
      if (val) {
        this.user.addValidators([Validators.required]);
        this.password.addValidators([Validators.required]);
      } else {
        this.user.patchValue(null);
        this.user.clearValidators();
        this.user.updateValueAndValidity();
        this.password.patchValue(null);
        this.password.clearValidators();
        this.password.updateValueAndValidity();
      }
    });

    if (this.mode === CreationMode.Edit) {
      this.user?.value && this.useCredentials.patchValue(true);
    }
  }

  get user(): FormControl {
    return this.form.get('user') as FormControl;
  }

  get password(): FormControl {
    return this.form.get('password') as FormControl;
  }
}
